import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { OrderAction } from '@frontend/order/types';
import { WorkflowAction } from '@frontend/workflow/types';

const ID = 'order-action-select';

export interface OrderActionSelectProps extends Omit<SelectInputV2Props<string>, 'options'> {}

export const OrderActionSelect = (props: OrderActionSelectProps) => (
    <SelectInputV2
        {...props}
        id={ID + props.id}
        label={props.label || 'Order action'}
        options={[...OrderAction.ALL, ...WorkflowAction.ALL].map((action) => ({ value: action.value, label: action.value, display: action.displayName }))}
    />
);

export default OrderActionSelect;
